import { atom } from 'jotai';
import { filterAtomDefaults } from '@/consts/defaults/filterAtomDefaults';
import { comparisonFiltersAtom } from './comparison';

export const resetComparisonFiltersAtom = atom(null, (_, set) => {
  set(comparisonFiltersAtom, { ...filterAtomDefaults });
});
